import styled from "styled-components";

export const TargetMetricWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 44px;
`;

export const ChannelMetricWrapper = styled.div`
  display: flex;
  gap: 18px;
  justify-content: ${({ isFirstColumn }) => (isFirstColumn ? "" : "center")};
`;

export const Metrics = styled.div`
  display: flex;
  flex-direction: column;
  gap: 29px;
`;

export const MetricsValue = styled.div`
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Channels = styled.div`
  display: flex;
  flex-direction: column;
  gap: 29px;
`;

export const ValuePercentage = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const Value = styled.div`
  color: ${({ theme }) => theme.colors.dataViz.printMetricsValueColor};
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
`;

export const Percentage = styled.div`
  color: ${({ theme }) => theme.colors.dataViz.printMetricsPercentageColor};
  font-size: 13px;
  font-weight: 400;
  line-height: normal;
`;

export const WinnerWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  color: ${({ theme }) => theme.colors.dataViz.winnerTextColor};
`;

export const WinnerDot = styled.div`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.dataViz.winnerDotColor};
`;

export const EmptyDot = styled.div`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: transparent;
`;
